import { render, staticRenderFns } from "./PermissionContent.vue?vue&type=template&id=88225a90&scoped=true"
import script from "./PermissionContent.vue?vue&type=script&lang=js"
export * from "./PermissionContent.vue?vue&type=script&lang=js"
import style0 from "./PermissionContent.vue?vue&type=style&index=0&id=88225a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88225a90",
  null
  
)

export default component.exports